import React from 'react';

/** Original CDS wallet placeholders while provider data is loading. */
export default function CdsWalletSkeleton() {
  return (
    <div className="cds-wallet-section__layout">
      <div
        className="cds-wallet-section__skeleton"
        role="status"
        aria-label="Cargando wallet CDS"
        aria-busy="true"
      >
        <span className="sr-only">Consultando puntos…</span>
        <div className="cds-wallet-section__skeleton-grid" aria-hidden="true">
          <div className="cds-wallet-section__skeleton-identity">
            <div className="cds-wallet-section__placeholder cds-wallet-section__placeholder--logo" />
            <div className="cds-wallet-section__placeholder cds-wallet-section__placeholder--category" />
          </div>
          <div className="cds-wallet-section__skeleton-balance">
            <div className="cds-wallet-section__placeholder cds-wallet-section__placeholder--amount" />
            <div className="cds-wallet-section__placeholder cds-wallet-section__placeholder--caption" />
          </div>
          <div className="cds-wallet-section__skeleton-detail">
            <div className="cds-wallet-section__placeholder cds-wallet-section__placeholder--detail" />
          </div>
          <div className="cds-wallet-section__skeleton-footer">
            <div className="cds-wallet-section__placeholder cds-wallet-section__placeholder--action" />
          </div>
        </div>
      </div>
    </div>
  );
}
